import React, { useState } from 'react';
import './AvailabilityStep.css';

const timeSlots = [
  { id: 'morning', label: 'Morning', time: '8:00 AM - 12:00 PM' },
  { id: 'afternoon', label: 'Afternoon', time: '12:00 PM - 4:00 PM' },
  { id: 'evening', label: 'Evening', time: '4:00 PM - 8:00 PM' },
  { id: 'night', label: 'Night', time: '8:00 PM - 12:00 AM' }
];

const weekDays = [
  'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
];

const AvailabilityStep = ({ onNext, onBack, onDataUpdate, data }) => {
  const [availability, setAvailability] = useState(data.availability || []);

  const isTimeSlotSelected = (day, slot) => {
    return availability.some(item => item.day === day && item.slot === slot);
  };

  const toggleTimeSlot = (day, slot) => {
    const newAvailability = [...availability];
    const existingIndex = newAvailability.findIndex(
      item => item.day === day && item.slot === slot
    );

    if (existingIndex >= 0) {
      newAvailability.splice(existingIndex, 1);
    } else {
      newAvailability.push({ day, slot });
    }

    setAvailability(newAvailability);
    onDataUpdate({ availability: newAvailability });
  };

  return (
    <div className="availability-step">
      <h1>Set your availability</h1>
      <p className="subtitle">Select the time slots when you're available to share your expertise</p>

      <div className="availability-grid">
        <div className="time-slots-header">
          <div className="day-column"></div>
          {timeSlots.map(slot => (
            <div key={slot.id} className="time-slot-header">
              <h3>{slot.label}</h3>
              <p>{slot.time}</p>
            </div>
          ))}
        </div>

        {weekDays.map(day => (
          <div key={day} className="day-row">
            <div className="day-label">{day}</div>
            {timeSlots.map(slot => (
              <button
                key={`${day}-${slot.id}`}
                className={`time-slot ${isTimeSlotSelected(day, slot.id) ? 'selected' : ''}`}
                onClick={() => toggleTimeSlot(day, slot.id)}
              >
                {isTimeSlotSelected(day, slot.id) && <span className="checkmark">✓</span>}
              </button>
            ))}
          </div>
        ))}
      </div>

      <div className="step-actions">
        <button 
          className="next-button"
          onClick={onNext}
          disabled={availability.length === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AvailabilityStep; 